import styled from "styled-components";

export const Content = styled.div`
  position: absolute;
  background-color: #f1f1f1;
  width: 46px;

  bottom: 100%;
  background: #FFFFFF;

  border: 1px solid #E3E3E3;
  box-sizing: border-box;

  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 12px;

  z-index: 10;

  font-weight: 400;
  color: ${window?.settings?.secondary_color ?? '#04333b'};

  margin-bottom: 5px;
`;